import React, { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { DEFAULT_DOCUMENT_TITLE } from '../hooks/useDocumentTitle';

// Titre d'onglet par route : le nom de la page ouverte, tel quel. Deux routes
// sont volontairement absentes — leur écran pose son propre titre :
// /projects/:projectId (CanvasFlow pose « nom du projet - Rabbit Prompt ») et les
// coquilles du footer (PlaceholderPage pose son titre). Les alias legacy
// (redirects Navigate) sont mappés pour éviter un flash pendant la redirection.
const ROUTE_TITLES: ReadonlyArray<readonly [string, string]> = [
  ['/', DEFAULT_DOCUMENT_TITLE],
  ['/pricing', 'Pricing'],
  ['/credits', 'How credits work'],
  ['/api', 'ComfyUI API'],
  ['/product', 'Product'],
  ['/login', 'Log in'],
  ['/signup', 'Log in'],
  ['/email-verification', 'Email verification'],
  ['/projects', 'Projects'],
  ['/welcome', 'Projects'],
  ['/explore', 'Explore'],
  ['/slots', 'Slots'],
  ['/connectors', 'Slots'],
  ['/custom-connectors', 'Slots'],
  ['/rabbits', 'Rabbits'],
  ['/rabbits/new', 'New rabbit'],
  ['/rabbits/new_character', 'New rabbit'],
  ['/rabbits/new_product', 'New rabbit'],
  ['/rabbits/paywall', 'Rabbits'],
  ['/rabbits/dataset/:characterId', 'Rabbit dataset'],
  ['/custom-models', 'Rabbits'],
  ['/loras', 'Rabbits'],
  ['/characters', 'Rabbits'],
  ['/content', 'Content'],
  ['/templates', 'Templates'],
  ['/prompt-set', 'Prompt sets'],
  ['/prompt-set/new', 'New prompt set'],
  ['/prompt-sets', 'Prompt sets'],
  ['/favorite', 'Favorites'],
  ['/favorite-prompts', 'Favorites'],
  ['/membership/pricing', 'Pricing'],
  ['/help', 'Help'],
  ['/apps', 'Apps'],
  ['/add-prompt', 'Add prompt'],
  ['/settings/:section?', 'Settings'],
  ['/admin-datadog', 'Admin — Logs'],
  ['/admin-datadog/design', 'Admin — Design system'],
  ['/design/:section?', 'Design system'],
  ['/design-system', 'Design system'],
  ['/admin-datadog/admins', 'Admin — Admins'],
  ['/admin-datadog/beta-users', 'Admin — Beta users'],
  ['/admin-datadog/usage-estimation', 'Admin — Usage estimation'],
  ['/admin-datadog/define-usage', 'Admin — Define usage'],
  ['/admin-datadog/prompts', 'Admin — Prompts'],
  ['/admin-datadog/logs', 'Admin — Logs'],
  ['/admin-datadog/paywalls', 'Admin — Paywalls'],
  ['/admin-datadog/models', 'Admin — Models'],
  ['/admin-users', 'Admin — Admins'],
];

// Synchronise le titre de l'onglet navigateur avec la route courante. Monté
// dans AppRoutes (sous <Router>) à côté de ScrollToTop.
export const DocumentTitleSync: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    for (const [pattern, title] of ROUTE_TITLES) {
      if (matchPath(pattern, pathname)) {
        document.title = title;
        return;
      }
    }
    // Route non listée (canvas projet, PlaceholderPage, 404…) : l'écran
    // concerné pose son propre titre — ne pas écraser.
  }, [pathname]);

  return null;
};

export default DocumentTitleSync;
